import { createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  getMasterChecklist: ['payload'],
  getMasterChecklistStart: ['payload'],
  getMasterChecklistSuccess: ['payload'],
  getMasterChecklistFailure: ['payload'],

  getRepoChecklist: ['payload'],
  getRepoChecklistStart: ['payload'],
  getRepoChecklistSuccess: ['payload'],
  getRepoChecklistFailure: ['payload'],

  setMasterChecklistSearchQueries: ['payload'],
  resetMasterChecklistSearchQueries: ['payload'],

  setRepoChecklistSearchQueries: ['payload'],
  resetRepoChecklistSearchQueries: ['payload']
});
